import { render, staticRenderFns } from "./DocumentExplorer.vue?vue&type=template&id=48ca766e&scoped=true&"
import script from "./DocumentExplorer.vue?vue&type=script&lang=js&"
export * from "./DocumentExplorer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentExplorer.vue?vue&type=style&index=0&id=48ca766e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca766e",
  null
  
)

export default component.exports